import { useState } from 'react';
import { useAuth } from '@/context/AuthContext';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { Loader2 } from 'lucide-react';

const Auth = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [fullName, setFullName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { signIn, signUp } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      if (isLogin) {
        await signIn(email, password);
      } else {
        await signUp(email, password, fullName);
      }
    } catch (error) {
      console.error('Error de autenticación:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  /* clases que cambian según la prop bg */
  const bgClass = {
    sunset: 'bg-sunset',
    night:  'bg-night',
    black:  'bg-black',
    loginOptionA: 'bg-login-option-a',
    loginOptionB: 'bg-login-option-b',
    loginOptionC: 'bg-login-option-c'
  };

  const bg = bgClass.loginOptionA;
  const accentBar = bg === 'black' ? 'bg-brand-100' : 'bg-transparent';

  return (
    <div className={`min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4 ${bg}`}>
      <img className="mb-1" src="images/logo.png" alt="Logo" style={{ height: '120px', maxWidth: 'auto' }} />
      <h3 className="font-semibold text-black mb-5">Sistema de Gestión de Alquiler de Bicicletas</h3>

      <Card className="w-full max-w-md">
        <div className="text-center font-bold text-lg mt-5">Inicia Sesión</div>

        <form onSubmit={handleSubmit}>
          <CardContent className="space-y-4 pt-4">
            <div className="space-y-2">
              <Label htmlFor="email">Correo Electrónico</Label>
              <Input 
                id="email"
                type="email"
                placeholder="Ingresa tu correo electrónico"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="space-y-2">
              <div className="flex items-center justify-between">
                <Label htmlFor="password">Contraseña</Label>
              </div>
              <Input 
                id="password"
                type="password"
                placeholder="Ingresa tu contraseña"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
          </CardContent>
          <CardFooter className="flex flex-col">
            <Button className="w-full" type="submit" disabled={isSubmitting}>
              {isSubmitting ? (
                <>
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  Iniciando sesión...
                </>
              ) : (
                'Iniciar Sesión'
              )}
            </Button>
            <a href="/forgot-password" className="mt-4 text-sm text-center text-bike-600 hover:underline">
              ¿Olvidaste tu contraseña?
            </a>
          </CardFooter>
        </form>
      </Card>
    </div>
  );
};

export default Auth;
